import { connect } from 'react-redux';
import Events from './Events';
import { getFormValues } from 'redux-form';

const mapStateToProps = state => ({
  formValues: getFormValues('Events')(state)
});

export default connect(mapStateToProps, {})(Events);